// 获取分流
export const getLandAb = () => {
  // 0923 全量切java流程
  return true
}

export const getSessionId = () => {
  let sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = '';
    for (let i = 0; i < 32; i++) {
      sessionId += Math.floor(Math.random() * 10); // 每次生成一个0-9的数字
    }
    localStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
}

const TRAFFIC_TAG_KEY = 'traffic-tag';

/** 获取本地存储的 traffic-tag */
export const getTrafficTag = () => {
  return localStorage.getItem(TRAFFIC_TAG_KEY) || '';
};

/** 设置 traffic-tag 到本地 */
export const setTrafficTag = (value) => {
  if (value == null || value === '') {
    localStorage.removeItem(TRAFFIC_TAG_KEY);
  } else {
    localStorage.setItem(TRAFFIC_TAG_KEY, String(value).trim());
  }
};

/** 清除本地 traffic-tag */
export const removeTrafficTag = () => {
  localStorage.removeItem(TRAFFIC_TAG_KEY);
};

export const hostsMap = {
  prod: 'https://m.xinyongfei.cn', // 生产域名
  test: 'http://test-m.xinyongfei.cn', // test2域名
  local: 'http://test-m.xinyongfei.cn',
};

//百度下载页跳转协议地址
export function baiduXieYi(key){
  window.location.href = `https://m-v6.xinyongfei.cn/contract.html?key=${key}&type=profit`
}
export default {
  hostsMap,
  isHttps,
  delay,
  isIos,
  isIphoneX,
  getQueryString,
  checkPhone,
  checkCard,
  tId,
  getReportParams,
  preLoadImage
};
// 图片预加载
export function preLoadImage(url) {
  if (typeof url === 'string') {
    const image = new Image();
    image.src = url;
  }
  if (Array.isArray(url)) {
    const images = [];
    for (let i = 0; i < url.length; i++) {
      images[i] = new Image();
      images[i].src = url[i]
    }
  }
}

export function isHttps (url) {
  let tmp = false;
  if (url.includes('https')) {
    tmp = true;
  }
  return tmp;
}

const delay = ms => new Promise(res => setTimeout(res, ms));

export function isIos () {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  if (isAndroid) {
    return false;
  } else {
    return true;
  }
}

// export function isIos() {
//   let u = navigator.userAgent;
//   const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
//   console.log('isIos',isIos)
//   // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
//   if (isIos) {
//     return true; 
//   } else {
//     return false;
//   }
// }

export function isIphoneX () {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
  }
  return false;
}

//判断是wap、android还是ios
export function terminalFn () {
  let terminal = 'other';
  let u = navigator.userAgent;
  if (u.includes('Android') || u.includes('Adr')) {
    terminal = 'android';
  } else if (u.includes('iPhone')) {
    terminal = 'ios';
  }
  return terminal;
}

// 微信环境
export function isWx () {
  var u = navigator.userAgent.toLowerCase();
  if (u.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

// 支付宝小程序环境
export function isAliMin () {
  var u = navigator.userAgent.toLowerCase();
  if (u.indexOf('alipay') > -1 && u.indexOf('miniprogram') > -1) {
    return true;
  } else {
    return false;
  }
}

//支付宝环境
export function isAli () {
  var u = navigator.userAgent.toLowerCase();
  if (u.indexOf('alipay') > -1) {
    return true;
  } else {
    return false;
  }
}
export function isIongPhone () {
  if (window.screen.height >= 812) {
    return true;
  }
  return false;
}

//返回路由中指定的字符串
export function getQueryString (name, path) {
  let target = path ? path : window.location.search;
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = target.substr(1).match(reg);
  let value = "";
  if (r != null) {
    value = decodeURI(r[2]);
    if (name === 'utm_source') {
      let valueObj = '';
      try {
        valueObj = JSON.parse(value);
      } catch {
      }
      value = Array.isArray(valueObj) ? valueObj[0] : value;
    }
  }
  return value;
}

export function checkPhone (phone) {
  let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/,
    isPhone = reg.test(phone);

  return isPhone;
}

//银行卡
export function checkBankCard (userIdNum) {
  var reg = /^([1-9]{1})(\d{14}|\d{15}|\d{17}|\d{18})$/; //  首位不为0 总位数为 15 16 18 19位

  return reg.test(userIdNum);
}

//身份证
export function checkCard (userIdNum) {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

  return reg.test(userIdNum);
}

export const mergeRoutes = routes => routes.reduce((pre, next) => [...pre, ...next], []);

// 禁止页面滚动
export function stopDefault (el) {
  el.addEventListener(
    'touchmove',
    event => {
      event.preventDefault();
    },
    false
  );
}
// 恢复页面滚动
export function recoverDefault (el) {
  el.removeEventListener(
    'touchmove',
    event => {
      event.preventDefault();
    },
    false
  );
}

export function debounce (func, wait = 380) {
  let timeout = undefined;
  return function (...rest) {
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }
    const context = this;
    const args = rest;
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export function isInXyfApp () {
  const ua = window.navigator.userAgent;
  const xyfFlags = ['XYF-ANDROID', 'XYF-IOS', 'CW-IOS'];
  const index = xyfFlags.findIndex(ele => ua.indexOf(ele) !== -1);
  return index === -1 ? false : true;
}


//随机取数组某一位
export function randomArr (arr) {

  if (!arr || arr.length === 0) return '';

  return arr[Math.floor((Math.random() * arr.length))]

}

export function currentEnv () {
  const hostUrl = window.location.host;
  if (hostUrl.includes('192.168')) {
    return 'local'
  } else if (hostUrl.includes('test')) {
    return 'test'
  } else {
    return 'prod'
  }
}
export function isMobile () {
  const { body } = document;
  const BETTERWIDTH = 1024;
  const rect = body.getBoundingClientRect();
  return rect.width - 1 < BETTERWIDTH;
}

export function getRamNumber (len) {
  var result = '';
  for (var i = 0; i < len; i++) {
    result += Math.floor(Math.random() * 10)
  }

  //默认字母小写，手动转大写
  return result;//另toLowerCase()转小写
}

/**
 * 将路由参数解析成键值对
 * @param {*} searchStr
 */
export function parseQuerySearch (searchStr) {
  const resObj = {};
  const queryLists =
    searchStr.indexOf('?') !== -1 ? searchStr.substr(1).split('&') : searchStr.split('&');
  queryLists.forEach(item => {
    const [key, value] = item.split('=');
    resObj[key] = decodeURIComponent(value);
  });
  return resObj;
}




export const codeMap = {
  408101: 420001,
  406007: 420003,
  407120: 420004,
  407123: 420006,
  223032: 420006,
  223029: 420006,
  401014: 420007,
  400011: 420000,
  407124: 420010,
  407107: 420013,
  407101: 420014,
  402105: 420015,
  407119: 420016,
  407137: 420017,
  407105: 420018,
  407109: 420019,
  409008: 420020,
  407110: 420021,
};


export const printLog = function (params, res) {
  params = typeof params === 'object' ? params : JSON.parse(params);
  const { url, method } = params;
  console.group();
  console.log('------------------------------------');
  console.log(`url: ${url}`);
  console.log(`method: ${method}`);
  console.log(`request: `, params.data);
  console.log(`response: `, res);
  console.log('------------------------------------');
  console.groupEnd();
};

export const getEnv = () => {
  let env = '';
  if (location.origin.includes('localhost') || location.origin.includes('192.168')) {
    env = 'local'
  } else if (location.origin.includes('test')) {
    env = 'test'
  } else {
    env = 'prod'
  }
  return env
}

//判断手机品牌,返回跳转方式
export const judgeAppStoreUrlFromBrand = () => {
  let sUserAgent = navigator.userAgent.toLowerCase()
  let isHuawei = sUserAgent.match(/huawei/i) == "huawei";
  let isHonor = sUserAgent.match(/honor/i) == "honor";
  let isOppo = sUserAgent.match(/oppo/i) == "oppo" || sUserAgent.match(/pdym20/i) == 'pdym20';
  let isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
  let isVivo = sUserAgent.match(/vivo/i) == "vivo";
  let isXiaomi = sUserAgent.match(/mi\s/i) == "mi ";
  let isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix ";
  let isRedmi = sUserAgent.match(/redmi/i) == "redmi";
  let isSamsung = sUserAgent.match(/sm-/i) == "sm-";
  let meizu = sUserAgent.match(/meizu/i) == "meizu";
  if (isHuawei || isHonor) {
    return 'appmarket://details?id=com.xinyongfei.xyf';
    // return 'https://appgallery.huawei.com/app/C100011897';
  } else if (isOppo || isOppoR15) {
    return 'https://api.xinyongpurse.com/app/package/download?app=xyf'; //oppo 不加
    // return 'oppomarket://details?packagename=com.xinyongfei.xyf';
  } else if (isVivo) {
    return 'https://api.xinyongpurse.com/app/package/download?app=xyf';
  } else if (isXiaomi || isRedmi || isXiaomi2s) {
    return "mimarket://details?id=com.xinyongfei.xyf"
    // return 'https://app.mi.com/details?id=com.xinyongfei.xyf';
  } else if (meizu) {
    return 'flyme://details/id=com.xinyongfei.xyf';
  } else {
    return 'https://api.xinyongpurse.com/app/package/download?app=xyf';
  }
}

//判断手机品牌,返回跳转方式
export const judgeStoreUrlFromBrand = () => {
  let sUserAgent = navigator.userAgent.toLowerCase()
  let isHuawei = sUserAgent.match(/huawei/i) == "huawei";
  // let isHonor = sUserAgent.match(/honor/i) == "honor";
  let isOppo = sUserAgent.match(/oppo/i) == "oppo" || sUserAgent.match(/pdym20/i) == 'pdym20';
  let isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
  let isVivo = sUserAgent.match(/vivo/i) == "vivo";
  let isXiaomi = sUserAgent.match(/mi\s/i) == "mi ";
  let isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix ";
  let isRedmi = sUserAgent.match(/redmi/i) == "redmi";
  let isSamsung = sUserAgent.match(/sm-/i) == "sm-";
  let meizu = sUserAgent.match(/meizu/i) == "meizu";
  let isXiaoMiPin = sUserAgent.match(/xiaomi/i) == "xiaomi";
  if (isHuawei ) {
    return 'https://url.cloud.huawei.com/n18gij74ly';
    // return 'https://appgallery.huawei.com/app/C100011897';
  } else if (isOppo || isOppoR15) {
    return 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xinyongfei.xyf'; //oppo 不加
  } else if (isVivo) {
    return 'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=1830980&resource=301&source=2';
  } else if (isXiaomi || isRedmi || isXiaomi2s || isXiaoMiPin) {
    return "http://app.xiaomi.com/detail/467076"
  } else if (meizu) {
    return 'https://app.meizu.com/apps/public/detail?package_name=com.xinyongfei.xyf#';
  } else {
    return 'https://api.xinyongpurse.com/app/package/download?app=xyf';
  }
}
export function numFormat (num) { // num只传入整数
  num = num.toString().split(".");   // 分隔小数点
  let arr = num[0].split("").reverse();  // 转换成字符数组并且倒序排列
  let res = [];
  for (let i = 0, len = arr.length; i < len; i++) {
    if (i % 3 === 0 && i !== 0) {
      res.push(",");   // 添加分隔符
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if (num[1]) {  // 如果有小数的话添加小数部分
    res = res.join("").concat("." + num[1]);
  } else {
    res = res.join("");
  }
  return res;
}
// 将base64转换为文件
export function dataURLtoFile (dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}

export function getAppName () {
  return getQueryString('app_name') || sessionStorage.getItem('app_name')
}
export function getToken () {
  return getQueryString('token') || sessionStorage.getItem('SDKTOKEN')
}



export const ossBase = 'https://img.sfystatic.com/upload/tmp/images/activity/xyf-mobile'

export function tId () {
  var date = new Date();
  //年 getFullYear()：四位数字返回年份
  var year = date.getFullYear(); //getFullYear()代替getYear()
  //月 getMonth()：0 ~ 11
  var month = date.getMonth() + 1;
  month < 10 ? ('0' + month) : month;
  //日 getDate()：(1 ~ 31)
  var day = date.getDate();
  day < 10 ? ('0' + day) : day;
  //时 getHours()：(0 ~ 23)
  var hour = date.getHours();
  hour < 10 ? ('0' + hour) : hour;
  //分 getMinutes()： (0 ~ 59)
  var minute = date.getMinutes();
  minute < 10 ? ('0' + minute) : minute;
  //秒 getSeconds()：(0 ~ 59)
  var second = date.getSeconds();
  second < 10 ? ('0' + second) : second;
  //毫秒值
  let mis = date.getTime() % 1000;
  let length = 5 - (mis + '').length;
  mis = mis * Math.pow(10, length)
  var id = year + '' + month + '' + day + '' + hour + '' + minute + '' + second + '' + mis + '' + parseInt((Math.random() * (999999 - 100000) + 100000))
  return id
}
export function formatDate (dateStr) {
  var fmt = arguments.length <= 1 || arguments[1] === undefined ? 'yyyy-MM-dd hh:mm:ss' : arguments[1];

  if (!dateStr) return;
  var date = new Date(dateStr);
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds()
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ("" + date.getFullYear()).substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return fmt;
}
export function sessionTokenNew () {
  return formatDate(new Date(), 'yyyyMMddhhmmss') + random(12)
}
export function random (len = 6) {
  const chars = '0123456789';
  const maxPos = chars.length;
  let code = '';
  for (let i = 0; i < len; i++) {
    code += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return code + ''; // 直接转换为小写
}

export function getLinkType () {
  return sessionStorage.getItem('linkType') || ''
}

export function getHFM (time) {
  // 转换为时分秒
  let h = parseInt(time / 60 / 60 % 24)
  h = h < 10 ? '0' + h : h
  let m = parseInt(time / 60 % 60)
  m = m < 10 ? '0' + m : m
  let s = parseInt(time % 60)
  s = s < 10 ? '0' + s : s
  // 作为返回值返回
  return `${h}:${m}:${s}`
}

export function MillisecondToDate (msd) {
  let time = parseFloat(msd) / 1000;
  if (null != time && "" != time) {
    if (time > 60 && time < 60 * 60) {
      time = parseInt(time / 60.0) + "min" + parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) + "s";
    } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
      time = parseInt(time / 3600.0) + "h" + parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + "min" + parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) - parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "s";
    } else {
      time = parseInt(time) + "s";
    }
  }
  return time;
};


export function getReportParams (data) {
  data.event_time = new Date().getTime();
  data.event_id = data.event_id + ''
  const from = localStorage.getItem('REPORT_FROM');
  if (from) {
    data.from = from;
  }
  let postData = {
    data: [data],
    "is_encrypt": 0
  };
  postData.data = JSON.stringify(postData.data);
  if (data.utm_source) {
    postData.utm_source = data.utm_source;
  } else {
    if (location.search.includes('utm_source=')) {
      if (location.search.split('utm_source=')[1].split('&')[0]) {
        postData.utm_source = location.search.split('utm_source=')[1].split('&')[0];
      }
    }
    // if (location.search.includes('utm_source=')) {
    //   if (location.search.split('utm_source=')[1].split('&')[0]) {
    //     let utmTest = data.type.substring(3);
    //     postData.utm_source = location.search.split('utm_source=')[1].split('&')[0];
    //     if(utmTest == '60' || utmTest == '61' ||  utmTest == '62' || utmTest == '63'){
    //       postData.utm_source =  postData.utm_source + '-' + utmTest;
    //     }
    //   }
    // }
  }
  return postData;
}

export function getSessionToken() {
    const sessionToken = 'SESSIONTOKEN';
    let token = localStorage.getItem(sessionToken);
      if(!token){
        token = sessionTokenNew()
        localStorage.setItem(sessionToken, token);
      }
    return token
}

export function getSecondsPassedToday() {
  // 获取当前时间
  let now = new Date();
  let currentHours = now.getHours();
  let currentMinutes = now.getMinutes();
  let currentSeconds = now.getSeconds();

  // 计算当天已经过去的秒数
  let secondsPassed = currentHours * 3600 + currentMinutes * 60 + currentSeconds;

  return secondsPassed;
}

export function getTimeDiffToNextDay(inputTime) {
  // 将输入的时间转换为秒数
  let hours = parseInt(inputTime.substring(0, 2));
  let minutes = parseInt(inputTime.substring(2, 4));
  let seconds = parseInt(inputTime.substring(4, 6));
  let inputSeconds = hours * 3600 + minutes * 60 + seconds;

  // 第二天同一时刻的时间对应的秒数
  let nextDaySeconds = 24 * 3600;

  // 计算剩余时间的秒数
  let remainingSeconds = nextDaySeconds - (getSecondsPassedToday() - inputSeconds);
  // 将剩余时间的秒数转换为HH:mm:ss格式
  let hoursRemaining = (Math.floor(remainingSeconds / 3600) % 24);
  let minutesRemaining = Math.floor((remainingSeconds % 3600) / 60);
  let secondsRemaining = remainingSeconds % 60;

  // 格式化输出时间
  let outputTime = `${String(hoursRemaining).padStart(2, '0')}:${String(minutesRemaining).padStart(2, '0')}:${String(secondsRemaining).padStart(2, '0')}`;

  return outputTime;
}

export function formatSessionTimeString() {
  const timeString = getSessionToken();
  let year = timeString.substring(0, 4);
  let month = timeString.substring(4, 6);
  let day = timeString.substring(6, 8);
  let hour = timeString.substring(8, 10);
  let minute = timeString.substring(10, 12);
  let second = timeString.substring(12, 14);

  let formattedDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  return formattedDateTime;
}


export function isTimeDifferenceThan24Hours (time) {
  let date1 = new Date(time);
  let date2 = new Date();

  let timeDiff = Math.abs(date2 - date1); // 时间差的毫秒数
  let hoursDiff = timeDiff / (1000 * 3600); // 时间差的小时数

  return hoursDiff > 24;
}

export const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  let browserName = 'Unknown';

  // Opera 15+
  if (userAgent.indexOf('OPR') > -1) {
    browserName = 'Opera';
  } else if (userAgent.indexOf('Firefox') > -1) {
    browserName = 'Firefox';
  } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    browserName = 'Safari';
  } else if (userAgent.indexOf('Chrome') > -1) {
    browserName = 'Chrome';
    // Edge 使用了 Chromium 内核，但可以通过 Edg/ 字符串进一步区分
    if (userAgent.indexOf('Edg') > -1) {
      browserName = 'Edge';
    }
  } else if (userAgent.indexOf('Trident') > -1) {
    browserName = 'Internet Explorer';
  }

  return browserName;
}


export const urlParamsToJson = () => {
  var params = {};
  var urlParts = window.location.href.split("?");

  if (urlParts.length > 1) {
      var queryString = urlParts[1];
      var paramArray = queryString.split("&");

      paramArray.forEach(function(param) {
          var paramParts = param.split("=");
          var key = decodeURIComponent(paramParts[0]);
          var value = decodeURIComponent(paramParts[1]);
          params[key] = value;
      });
  }
  return params || {};
}

// 根据数组筛选obj
export const filterObjectByKeys = (obj, keysArray) => {
  return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => keysArray.includes(key))
  );
};

export function getOS(defaultValue = 'Android') {
  try {
    const userAgent = (navigator.userAgent || '').toLowerCase();
    const platform = (navigator.platform || '').toLowerCase();

    if (!userAgent && !platform) {
      return defaultValue;
    }

    if (userAgent.includes('win')) return 'Windows';
    if (userAgent.includes('mac')) return 'MacOS';
    if (userAgent.includes('linux')) return 'Linux';
    if (userAgent.includes('android')) return 'Android';
    if (userAgent.includes('iphone') || userAgent.includes('ipad')) return 'iOS';

    return platform || defaultValue;
  } catch (error) {
    console.warn('获取操作系统类型失败:', error);
    return defaultValue;
  }
}

export function getOSVersion(defaultValue = '1.0.0') {
  try {
    const userAgent = (navigator.userAgent || '').toLowerCase();
    if (!userAgent) {
      return defaultValue;
    }

    // Windows
    const windowsMatch = userAgent.match(/windows nt (\d+\.\d+)/);
    if (windowsMatch) {
      const versionMap = {
        '10.0': '10',
        '6.3': '8.1',
        '6.2': '8',
        '6.1': '7',
        '6.0': 'Vista',
        '5.2': 'XP',
        '5.1': 'XP',
        '5.0': '2000'
      };
      return versionMap[windowsMatch[1]] || windowsMatch[1] || defaultValue;
    }

    // MacOS
    const macMatch = userAgent.match(/mac os x (\d+[._]\d+[._]\d+)/);
    if (macMatch) {
      return macMatch[1].replace(/_/g, '.') || defaultValue;
    }

    // iOS
    const iosMatch = userAgent.match(/os (\d+_\d+(_\d+)?)/);
    if (iosMatch) {
      return iosMatch[1].replace(/_/g, '.') || defaultValue;
    }

    // Android
    const androidMatch = userAgent.match(/android (\d+(\.\d+)*)/);
    if (androidMatch) {
      return androidMatch[1] || defaultValue;
    }

    return defaultValue;
  } catch (error) {
    console.warn('获取操作系统版本失败:', error);
    return defaultValue;
  }
}